<!-- 信息展示基础布局组件：模块头+组件内容 -->
<template>
<div class="content-block">
  <div class="info-list-title" v-if="showTitle">
    <span>{{title}}</span>
    <label>{{label}}</label>
    <router-link v-if="showMore" :to="{path:moreLink}">更多</router-link>
  </div>
  <div class="info-list-content">
    <ul>
      <li>
          <component :is="infoBlock" :info="info"/></component>
      </li>
    </ul>
    <div class="no-record" v-if="info=={}">暂无数据</div>
  </div>
</div>
</template>
<script>
export default {
  name: 'InfoContent',
  components:{},
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    showMore: {
      type: Boolean,
      default: true
    },
    moreLink: {
      type: String,
      default: "/"
    },
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: String,
      default: '16'
    },
    label: {
      type: String,
      default: ''
    },
    count: {
      type: String,
      default: '3'
    },
    infoBlock:{
      type:Object,
      default:function(){return {}}
    },
    info:{
      type:Object,
      default:function(){return {}}
    }
  },
  data() {
    return {

    }
  },
  methods:{
    queryPage:function(params){
      //console.log("查询分页数据："+JSON.stringify(params));
      //this.$emit("queryPage",params);
    }
  },
  created:function(){
    //this.infoList=this.Global.newsListDemo.slice(0,this.count);
    //this.queryPage({page:1,pageSize:this.count,title:this.title});
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display:block;
  position:relative;
  margin: 0px 0px 0px 0px;
  padding:0px;
  height:100%;
  text-align:left;
  //background:red;
}
.no-record{
  position:relative;
  height:40px;
  background:#eee;
  font-size:12px;
  text-align:center;
  line-height:40px;
  color:#888888;
}
</style>



// WEBPACK FOOTER //
// src/components/block/InfoContent.vue